import { gql } from '@apollo/client';
import { DOCUMENT_FIELDS } from '@/graphql/queries/documents';

export const GET_CARRIER_DOCUMENTS = gql`
    ${DOCUMENT_FIELDS}

    query GetCarrierDocuments($carrier_id: uuid!, $organization_id: uuid!) {
        documents(
            where: {
                _and: [
                    { client_id: { _eq: $carrier_id } }
                    { organization_id: { _eq: $organization_id } }
                    { type: { _in: ["AGREEMENT", "RATES", "NDA", "COI", "WORKERS_COMP", "W9", "MISC"] } }
                ]
            }
        ) {
            ...DocumentFields
            signed_on
            term_months
        }
    }
`;

// The org's compliance decisions on the carrier, newest first, with the document each one is on.
export const GET_CARRIER_COMPLIANCE_REVIEWS = gql`
    query GetCarrierComplianceReviews($carrier_id: uuid!, $organization_id: uuid!) {
        contractor_compliance_reviews(
            where: { contractor_id: { _eq: $carrier_id }, organization_id: { _eq: $organization_id } }
            order_by: { reviewed_at: desc }
        ) {
            review_id
            document_id
            status
            note
            reviewed_at
            document {
                document_id
                name
                type
                partner_client_id
            }
            reviewer {
                user_id
                username
                email
            }
        }
    }
`;
